module.exports = __webpack_public_path__ + "img/phone.96d6b9b4.svg";